import {
  Navigate,
  Route,
  RouterProvider,
  Routes,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";

import {
  Login,
  UserList,
  BullUpload,
  CreateSMSTemplate,
  EmailList,
  CreateEmailTemplate,
  UserRole,
  CreateUserRole,
  CreateInvoice,
  Overview,
  InvoiceList,
  InvoicePayment,
  Profile,
} from "../container";
import { MainLayout } from "../Layout";
import SMSList from "../container/templates/SMSList";
import { authService } from "../service";
import WhatsappList from "../container/templates/WhatsappList";

function Router() {
  const ErrorBoundary = () => {
    return <p>Oops! error occured</p>;
  };

  const browserRoute = createBrowserRouter(
    createRoutesFromElements(
      <Route ErrorBoundary={ErrorBoundary} path="*" element={<AuthRoute />} />
    )
  );

  return <RouterProvider router={browserRoute} />;
}

function AuthRoute() {
  const userData =
    (sessionStorage?.getItem("userDetail") &&
      JSON.parse(authService.dec(sessionStorage.getItem("userDetail")))) ||
    null;
  const isAuth = userData?.userinfo?.isactive;

  return isAuth ? <ProtectedRoute /> : <UnProtectedRoute />;
}

function ProtectedRoute() {
  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        <Route index element={<Overview />} />
        <Route path="overview" element={<Overview />} />
        <Route path="campaign">
          <Route path="invoice">
            <Route index element={<InvoiceList />} />
            <Route path="createinvoice" element={<CreateInvoice />} />
          </Route>
          <Route path="bulkupload" element={<BullUpload />} />
        </Route>
        <Route path="templates">
          <Route path="sms">
            <Route index element={<SMSList />} />
            <Route path="createsmstemplate" element={<CreateSMSTemplate />} />
          </Route>
          <Route path="email">
            <Route index element={<EmailList />} />
            <Route
              path="createemailtemplate"
              element={<CreateEmailTemplate />}
            />
          </Route>
          <Route path="whatsapp">
            <Route index element={<WhatsappList />} />
          </Route>
        </Route>
        <Route path="user">
          <Route path="list" element={<UserList />} />
          <Route path="role">
            <Route index element={<UserRole />} />
            <Route path="createuserrole" element={<CreateUserRole />} />
          </Route>
        </Route>
        <Route path="profile" element={<Profile />} />
      </Route>
      <Route path="*" element={<Redirect />} />
    </Routes>
  );
}

function UnProtectedRoute() {
  return (
    <Routes>
      <Route exact path="/" element={<Login />} />
      <Route path="/login/callback" element={<Login />} />
      <Route path="/paymentlounge/payment" element={<InvoicePayment />} />
      <Route path="*" element={<Redirect />} />
    </Routes>
  );
}

function Redirect() {
  return <Navigate to={"/"} />;
}
export default Router;
